var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "shrink-0 hidden md:inline-block",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 1.66675C13.3066 1.66675 16.6666 5.02675 16.6666 9.16675C16.6666 13.3067 13.3066 16.6667 9.16663 16.6667C5.02663 16.6667 1.66663 13.3067 1.66663 9.16675C1.66663 5.02675 5.02663 1.66675 9.16663 1.66675ZM9.16663 15.0001C12.3891 15.0001 15 12.3892 15 9.16675C15 5.94341 12.3891 3.33341 9.16663 3.33341C5.94329 3.33341 3.33329 5.94341 3.33329 9.16675C3.33329 12.3892 5.94329 15.0001 9.16663 15.0001ZM16.2375 15.0592L18.595 17.4159L17.4158 18.5951L15.0591 16.2376L16.2375 15.0592Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b3702fafc08bf42b04e6566194e93f72.svg";
export { ForwardRef as ReactComponent };